import React from 'react';

function Header() {
  return (
    <header className="App-header">
      <div className="header-content">
        <div className="logo">✍️</div>
        <div className="title-container">
          <h1>Social Media Writer</h1>
          <p>Generate customized content for Twitter and LinkedIn</p>
        </div>
      </div>
    </header>
  );
}

export default Header; 